import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingBorrowerSelectionDiagram = () => (
  <Diagram viewBox="0 0 300 110">
    <DiagramBox x={60} y={6} width={180} height={98} />
    <DiagramText x={150} y={22} tone={TextTone.MUTED} small tId="CUSTOMER_CHECKOUT" />
    {[
      { label: 'A', amount: '45 €', y: 30, chosen: false },
      { label: 'B', amount: '44 €', y: 54, chosen: true },
      { label: 'C', amount: '47 €', y: 78, chosen: false },
    ].map(({ label, amount, y, chosen }) => (
      <g key={label}>
        <DiagramBox x={72} y={y} width={156} height={18} tone={chosen ? BoxTone.HIGHLIGHT : BoxTone.NEUTRAL} />
        <DiagramText x={80} y={y + 13} anchor="start" bold={chosen} tId="INSTALMENTS_OF">
          {`${label} · 12 `}
        </DiagramText>
        <DiagramText x={220} y={y + 13} anchor="end" bold={chosen}>
          {amount}
        </DiagramText>
      </g>
    ))}
    <DiagramText x={248} y={70} anchor="start">
      ☝
    </DiagramText>
  </Diagram>
);
